import { colorSubText } from "../../../theme";

export const cellStyle = {
  color: "black",
  fontSize: "0.85rem",
  fontWeight: 400,
  borderBottom: "1px solid rgba(40, 61, 107, 0.25)",
};


export const cellStyleBold = {
  color: colorSubText,
  fontSize: "0.85rem",
  fontWeight: "bold",
  borderBottom: "1px solid rgba(40, 61, 107, 0.25)",
};